// TODO delete this after a while
export default [
  {
    path: '',
    name: 'deprecated sale list',
    component: () => import('@/views/app/sale/list/page-list.vue'),
    meta: { title: 'Riwayat Penjualan' },
  },
  {
    path: ':id',
    name: 'deprecated sale detail',
    component: () => import('@/views/app/sale/show/page-show.vue'),
    meta: { title: 'Detail Penjualan' },
  },
]
